import { parsePhoneNumber } from 'libphonenumber-js'

export const getFormatted = phone => {
  try {
    const phoneNumber = parsePhoneNumber(phone, 'US')

    if (!phoneNumber) {
      return phone
    }

    return phoneNumber.formatNational()
  } catch (err) {
    return phone
  }
}

const getFlag = phone => {
  try {
    const phoneNumber = parsePhoneNumber(phone, 'US')

    if (!phoneNumber) {
      return ['us', null]
    }

    return [phoneNumber.country?.toLocaleLowerCase() ?? 'us', phoneNumber]
  } catch (err) {
    return ['us', null]
  }
}

export const getCountryData = phone => {
  const [flag, phoneNumber] = getFlag(phone)

  const code = flag.toLocaleUpperCase()
  const regionNames = new Intl.DisplayNames(['en'], { type: 'region' })
  const country = regionNames.of(code)

  const prefix = `+${phoneNumber?.countryCallingCode ?? 1}`

  return { flag, country, prefix }
}
